import { gql } from "./api";

interface LoginInput {
  username: String;
  password: String;
}

interface PasswordResetRequestInput {
    email: String;
}

interface OnboardAccountCheckInput {
  otp_key: String | undefined;
}

interface ChangePasswordRequestCheckInput {
    otp_key: String | undefined;
}

interface ChangePasswordInput {
    uuid: String;
    password: String;
    otp_token: String | undefined;
    request_type: String | undefined;
}

interface ChangeLanguageInput {
    uuid: String;
    language: String;
    token: String;
}

export const onboardAccountCheck = async({ otp_key }: OnboardAccountCheckInput) => {
     const response = await gql(
        {
            query: `
                mutation OnboardUserCodeCheck {
                    onboardUserCodeCheck(
                        onboardUserCodeCheckInput: {
                            otp_token: "${otp_key}"
                        }
                    ) {
                        email
                        uuid
                    }
                }
          `,
          returnFunc: 'onboardUserCodeCheck'
        }
    );
    return response;
}

export const passwordChangeRequestCheck = async({ otp_key }: ChangePasswordRequestCheckInput) => {
     const response = await gql(
        {
            query: `
                mutation PasswordResetCodeCheck {
                    passwordResetCodeCheck(
                        passwordResetCodeCheckInput: {
                            otp_token: "${otp_key}"
                        }
                    ) {
                        email
                        uuid
                    }
                }
          `,
          returnFunc: 'passwordResetCodeCheck'
        }
    );
    return response;
}


export const changePassword = async({ uuid, password, otp_token, request_type }: ChangePasswordInput) => {
     const response = await gql(
        {
            query: `
                mutation PasswordUpdateUser {
                    passwordUpdateUser(
                        updateUserPasswordInput: { uuid: "${uuid}", password: "${password}", otp_token: "${otp_token}", reset_type: "${request_type}" }
                    ) {
                        uuid
                    }
                }
          `,
          returnFunc: 'passwordUpdateUser'
        }
    );
    return response;
}


export const changeLanguage = async({ uuid, language, token }: ChangeLanguageInput) => {
     const response = await gql(
        {
            query: `
                mutation LanguageUpdateUser {
                    languageUpdateUser(
                        updateUserLanguageInput: { uuid: "${uuid}", lang: "${language}", token: "${token}", user_uuid: "${uuid}" }
                    ) {
                        uuid
                    }
                }
          `,
          returnFunc: 'languageUpdateUser'
        }
    );
    return response;
}

export const LoginAccount = async ({
  username,
  password
}: LoginInput) => {
    const response = await gql(
        {
            query: `
                mutation LoginUser {
                    loginUser(userInput: { email: "${username}", password: "${password}" }) {
                        uuid
                        token
                        email
                        firstname
                        lastname
                        job_title
                        level
                        exp
                        settings
                        activity
                        activity_chart
                        activity_phishing
                        organization {
                            name
                            shortname
                        }
                        progress {
                            id
                            chapter
                            label
                            available
                            status
                            description {
                                EN
                                NL
                            }
                            modules {
                                id
                                title
                                status
                                available
                                link
                                next
                                label {
                                    EN
                                    NL
                                }
                            }
                        }
                    }
                }
          `,
          returnFunc: 'loginUser'
        }
    );

  return response;
};

export const PasswordResetRequest = async({email}: PasswordResetRequestInput) => {

    const response = await gql({
        query: `
            mutation ResetPasswordRequest {
                resetPasswordRequest(resetPasswordRequestInput: { email: "${email}" }) {
                    email
                }
            }
        `,
        returnFunc: 'resetPasswordRequest'
    })

    return response
}

